import { applyMiddleware } from 'redux';
import { createStore, IModuleStore } from 'redux-dynamic-modules';
import { getSagaExtension } from 'redux-dynamic-modules-saga';
import { createLogger } from 'redux-logger';
import { ActionType } from 'typesafe-actions';
import { routerMiddleware } from 'connected-react-router';

import { getUrlParam } from 'common/util/url/urlUtil';
import { configureTrackJs } from 'common/services/ErrorReporting';

import history from '../services/HistoryService';
import { RootState } from './rootReducer';
import getRootModule from './rootModule';

const dispatchLogger = getUrlParam('dispatchLogger');
const middleware = [routerMiddleware(history)];

if (dispatchLogger) {
    middleware.push(createLogger());
}

interface StoreManager {
    store: IModuleStore<RootState>;
    createStore: () => IModuleStore<RootState>;
    dispatch: (action: ActionType<any>) => void;
    getState: () => RootState;
    getStore: () => IModuleStore<RootState>;
}

const storeManager: StoreManager = {
    store: undefined,

    createStore(initialState: any = {}) {
        storeManager.store = createStore(
            {
                initialState,
                extensions: [getSagaExtension({} /* saga context */)],
                enhancers: [applyMiddleware(...middleware)],
            },
            getRootModule(),
            /* ...any additional modules */
        );

        return storeManager.store;
    },

    dispatch(action: ActionType<any>) {
        return storeManager.store.dispatch(action);
    },

    getStore() {
        return storeManager.store;
    },

    getState() {
        return storeManager.store.getState();
    },
};

if (configureTrackJs) {
    configureTrackJs(window.userId);
}


export default storeManager;
